import React from "react";

type Props = {
  color?: string;
  onMouseMove?: React.MouseEventHandler<SVGSVGElement>;
};

export function CheckedIconPatientFacing({
  color = "#822949",
  onMouseMove,
}: Props) {
  return (
    <svg
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onMouseMove={onMouseMove}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13380_10874)">
        <path
          d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17.99 9L16.58 7.58L9.99 14.17L7.41 11.6L5.99 13.01L9.99 17L17.99 9Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_13380_10874">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
